import React from 'react';
import './App.css';
import Main from './component/Main';
import Login from './component/Login';
import ProtectedRoute from './component/ProtectedRoute';
import RoleBasedRoute from './component/RoleBasedRoute';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Biens from './component/bien/Biens';
import Locataires from './component/locataire/Locataires';
import Contrats from './component/contrat/Contrats';
import Paiements from './component/paiement/Paiements';
import Inscription from './component/incription/Inscription';
import VerifyEmail from './component/auth/VerifyEmail';
import ResendVerification from './component/auth/ResendVerification';
import ForgotPassword from './component/auth/ForgotPassword';
import ResetPassword from './component/auth/ResetPassword';
import DashboardAdmin from './component/dashboard/DashboardAdmin';
import DashboardProprietaire from './component/dashboard/DashboardProprietaire';
import DashboardLocataire from './component/dashboard/DashboardLocataire';
import { MesPaiements } from './component/paiement/MesPaiements';
import {ContratsLocataire} from './component/contrat/ContratsLocataire';
import { Profil } from './component/utilisateur/Profil';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Route publique pour la connexion */}
          <Route path='/login' element={<Login />} />
          
          {/* Route publique pour l'inscription */}
          <Route path='/inscription' element={<Inscription />} /> 
          
          {/* Routes publiques pour la vérification d'email */}
          <Route path='/verify-email' element={<VerifyEmail />} />
          <Route path='/resend-verification' element={<ResendVerification />} />
          
          {/* Routes publiques pour réinitialisation de mot de passe */}
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          
          {/* Routes protégées */}
          <Route path='/' element={
            <ProtectedRoute>
              <Main />
            </ProtectedRoute>
          }>
            {/* Route index - Dashboard selon le rôle */}
            <Route index element={
              <RoleBasedRoute 
                adminComponent={<DashboardAdmin />}
                proprietaireComponent={<DashboardProprietaire />}
                locataireComponent={<MesPaiements />}
              />
            } />
            
            {/* Routes pour les biens */}
            <Route path='biens' element={
              <RoleBasedRoute 
                adminComponent={<Biens />}
                proprietaireComponent={<Biens />}
                locataireComponent={<div className="p-6 text-center text-gray-500">Fonctionnalité non disponible</div>}
              />
            } />
            
            {/* Routes pour les locataires */}
            <Route path='locataires' element={
              <RoleBasedRoute 
                adminComponent={<Locataires />}
                proprietaireComponent={<Locataires />}
                locataireComponent={<div className="p-6 text-center text-gray-500">Fonctionnalité non disponible</div>}
              />
            } />
            
            {/* Routes pour les contrats */}
            <Route path='contrats' element={
              <RoleBasedRoute 
                adminComponent={<Contrats />}
                proprietaireComponent={<Contrats />}
                locataireComponent={<ContratsLocataire />}
              />
            } />
            
            {/* Routes pour les paiements */}
            <Route path='paiements' element={
              <RoleBasedRoute 
                adminComponent={<Paiements />}
                proprietaireComponent={<Paiements />}
                locataireComponent={<MesPaiements />}
              />
            } />

            {/* Route pour le profil - accessible par tous les rôles */}
            <Route path='profil' element={<Profil />} />

            {/* Routes spécifiques locataire */}
            <Route path='logement' element={
              <RoleBasedRoute 
                locataireComponent={<div className="p-6"><h2 className="text-2xl font-bold">Mon Logement</h2></div>}
                fallback={<div className="p-6 text-center text-gray-500">Fonctionnalité non disponible</div>}
              />
            } />
            
            <Route path='contrat' element={
              <RoleBasedRoute 
                locataireComponent={<div className="p-6"><h2 className="text-2xl font-bold">Mon Contrat</h2></div>}
                fallback={<div className="p-6 text-center text-gray-500">Fonctionnalité non disponible</div>}
              />
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
